import {
  LIST_NAME_LENGTH_SOFT_LIMIT,
  LIST_DESCRIPTION_LENGTH_SOFT_LIMIT,
  VISIBILITY
} from 'app/constants/ListEditorConstants';

export const generateKeyForListItem = item => {
  if (item.get('type') === 'url') {
    return `${item.get('type')}-${item.getIn(['urlListItem', 'url', 'url'])}`;
  }
  return `${item.get('type')}-${item.getIn(['bibListItem', 'id'])}`;
};

export const getListVisibilityType = list => {
  if (list.get('visibility')) {
    return list.get('visibility');
  }

  return VISIBILITY.NOT_VISIBLE;
};

export const isReadalikeList = list => list.get('listType') === 'read_a_like';

export const isStaffOnlyList = list =>
  ['staff_picks', 'languages', 'default_newly_acquired', 'admin_newly_acquired', 'teacher_picks'].indexOf(
    list.get('listType')
  ) !== -1;

export const listNameIsTooLong = list => list.get('name', '').length > LIST_NAME_LENGTH_SOFT_LIMIT;

export const listDescriptionIsTooLong = list => list.get('description', '').length > LIST_DESCRIPTION_LENGTH_SOFT_LIMIT;
